// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1qI3Y","content":"RecentSearches_content__8RK4O"};